import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  QAREPA_API_ERROR_MESSAGES,
  QarepaApiErrorPresenter,
} from '@qarepa/common';
import { SnackbarConfig } from 'libono';

@Injectable({
  providedIn: 'root',
})
export class ApiErrorPresenter implements QarepaApiErrorPresenter {
  private readonly snackbar = inject(MatSnackBar);
  private readonly messages = inject(QAREPA_API_ERROR_MESSAGES);

  showConnectionError(): void {
    this.open(this.messages.connectionError);
  }

  showServerError(): void {
    this.open(this.messages.serverError);
  }

  showUnauthorized(): void {
    this.open(this.messages.unauthorized);
  }

  showForbidden(): void {
    this.open(this.messages.forbidden);
  }

  showApiError(message: string): void {
    this.open(message);
  }

  private open(message: string): void {
    this.snackbar.open(message, SnackbarConfig.strings.close, {
      panelClass: SnackbarConfig.classes.danger,
      duration: SnackbarConfig.durations.danger,
    });
  }
}
